(function () {
  'use strict';

  var CONFIG = {
    actions: {
      blurContent:  false,
      blockOverlay: false,
      redirect:     true
    },

    redirectUrl:    '/404',
    overlayMessage: 'This store is not available right now.',
    blurAmountPx:   8,

    rescanIntervalMs: 2000,
    maxRescans:       5,

    extensions: [
      {
        name: 'PPSPY',
        id: 'lppbajkahdbbadheilijoeegnfndhlab',
        resources: [
          'img/loading.png',
          'img/loading-dark.png',
          'img/ppspy_check_blue.svg',
          'img/tracking_default.svg'
        ],
        domKeywords: ['ppspy']
      },
      {
        name: 'TrendTrack',
        id: 'cncdmciajmaojninbopinpijdodjgfpd',
        resources: [
          'icon/128.png'
        ],
        domKeywords: ['trendtrack', 'trend-track']
      },
      {
        name: 'Winning Hunter',
        id: 'eijfgedfkehblhdaiommcibimdgfgbop',
        resources: [
          'icon.png',
          'icon128.png',
          'icons/icon128.png',
          'logo.png'
        ],
        domKeywords: ['winninghunter', 'winning-hunter']
      }
    ],

    referrerBlocklist: [
      'winninghunter.com',
      'ppspy.com',
      'trendtrack.io'
    ],

    utmKeywords: [
      'winninghunter',
      'ppspy',
      'trendtrack'
    ]
  };

  var fired = {};
  var actionsApplied = {};
  var ATTRS = ['src', 'href', 'data-src', 'style', 'background'];

  function onDetect(method, name) {
    var sig = method + '|' + name;

    if (fired[sig]) return;

    fired[sig] = true;
    runActions();
  }

  function runActions() {
    var a = CONFIG.actions;

    if (a.blurContent && !actionsApplied.blur) {
      actionsApplied.blur = true;
      applyBlur();
    }

    if (a.blockOverlay && !actionsApplied.overlay) {
      actionsApplied.overlay = true;
      showOverlay();
    }

    if (a.redirect && !actionsApplied.redirect) {
      actionsApplied.redirect = true;
      safeRedirect(CONFIG.redirectUrl);
    }
  }

  function safeRedirect(targetUrl) {
    try {
      var target = new URL(targetUrl, window.location.origin);

      if (
        window.location.pathname === target.pathname &&
        window.location.search === target.search
      ) {
        return;
      }

      window.location.replace(target.href);
    } catch (e) {
      try {
        window.location.href = targetUrl;
      } catch (err) {}
    }
  }

  function applyBlur() {
    var css =
      'filter:blur(' + CONFIG.blurAmountPx + 'px)!important;' +
      '-webkit-filter:blur(' + CONFIG.blurAmountPx + 'px)!important;' +
      'pointer-events:none!important;' +
      'user-select:none!important;';

    var apply = function () {
      if (!document.body) return;

      var existing = document.body.getAttribute('style') || '';

      if (existing && existing.slice(-1) !== ';') {
        existing += ';';
      }

      document.body.setAttribute('style', existing + css);
    };

    if (document.body) {
      apply();
    } else {
      document.addEventListener('DOMContentLoaded', apply);
    }
  }

  function showOverlay() {
    var build = function () {
      if (!document.body) return;
      if (document.getElementById('__antispy_overlay')) return;

      var d = document.createElement('div');
      d.id = '__antispy_overlay';

      d.setAttribute('style', [
        'position:fixed',
        'inset:0',
        'z-index:2147483647',
        'display:flex',
        'align-items:center',
        'justify-content:center',
        'background:#0b0b0c',
        'color:#fff',
        'font:600 20px/1.5 system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
        'text-align:center',
        'padding:24px'
      ].join(';'));

      d.textContent = CONFIG.overlayMessage;
      document.body.appendChild(d);
    };

    if (document.body) {
      build();
    } else {
      document.addEventListener('DOMContentLoaded', build);
    }
  }

  function inspectElement(el) {
    if (!el || el.nodeType !== 1) return;

    for (var i = 0; i < CONFIG.extensions.length; i++) {
      var ext = CONFIG.extensions[i];
      var needle = 'chrome-extension://' + ext.id;

      for (var j = 0; j < ATTRS.length; j++) {
        var v = el.getAttribute && el.getAttribute(ATTRS[j]);

        if (v && v.indexOf(needle) !== -1) {
          onDetect('extension-url', ext.name);
          return;
        }
      }

      var className = '';

      if (el.className) {
        className = el.className.baseVal
          ? el.className.baseVal
          : String(el.className);
      }

      var hay = (
        (el.id || '') + ' ' +
        className + ' ' +
        (el.getAttribute && (el.getAttribute('alt') || '')) + ' ' +
        (el.getAttribute && (el.getAttribute('src') || ''))
      ).toLowerCase();

      for (var k = 0; k < ext.domKeywords.length; k++) {
        if (hay.indexOf(ext.domKeywords[k]) !== -1) {
          onDetect('dom-keyword', ext.name);
          break;
        }
      }
    }
  }

  function scanDom(root) {
    try {
      var base = root || document;

      if (!base.querySelectorAll) return;

      var els = base.querySelectorAll('*');

      for (var i = 0; i < els.length; i++) {
        inspectElement(els[i]);

        if (els[i].shadowRoot) {
          scanDom(els[i].shadowRoot);
        }
      }
    } catch (e) {}
  }

  function watchDom() {
    if (typeof MutationObserver === 'undefined') return;
    if (!document.documentElement) return;

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];

          if (!node || node.nodeType !== 1) continue;

          inspectElement(node);

          if (node.querySelectorAll) {
            scanDom(node);
          }

          if (node.shadowRoot) {
            scanDom(node.shadowRoot);
          }
        }
      }
    });

    obs.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function probeImage(url) {
    return new Promise(function (resolve) {
      var img = new Image();
      var done = false;

      var finish = function (ok) {
        if (!done) {
          done = true;
          resolve(ok);
        }
      };

      img.onload = function () {
        finish(true);
      };

      img.onerror = function () {
        finish(false);
      };

      img.src = url;

      setTimeout(function () {
        finish(false);
      }, 2500);
    });
  }

  function probeFetch(url) {
    return fetch(url, { method: 'GET' })
      .then(function (r) {
        return !!r;
      })
      .catch(function () {
        return false;
      });
  }

  function probeExtensions() {
    CONFIG.extensions.forEach(function (ext) {
      ext.resources.forEach(function (res) {
        var url = 'chrome-extension://' + ext.id + '/' + res;
        var isImg = /\.(png|jpg|jpeg|gif|webp|svg|ico)$/i.test(res);
        var probe = isImg ? probeImage(url) : probeFetch(url);

        probe.then(function (ok) {
          if (ok) {
            onDetect('extension-probe', ext.name);
          }
        });
      });
    });
  }

  function hostMatches(host, blockedDomain) {
    host = (host || '').toLowerCase();
    blockedDomain = (blockedDomain || '').toLowerCase();

    return host === blockedDomain || host.endsWith('.' + blockedDomain);
  }

  function checkReferrer() {
    var ref = document.referrer || '';

    if (!ref) return;

    try {
      var host = new URL(ref).hostname;

      CONFIG.referrerBlocklist.forEach(function (dom) {
        if (hostMatches(host, dom)) {
          onDetect('referrer', dom);
        }
      });
    } catch (e) {}
  }

  function checkUtm() {
    var params;

    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (e) {
      return;
    }

    var fields = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'ref',
      'source'
    ];

    fields.forEach(function (field) {
      var value = (params.get(field) || '').toLowerCase();

      if (!value) return;

      CONFIG.utmKeywords.forEach(function (kw) {
        if (value.indexOf(kw.toLowerCase()) !== -1) {
          onDetect('utm', kw);
        }
      });
    });
  }

  function runImmediateChecks() {
    checkReferrer();
    checkUtm();
    probeExtensions();
  }

  function runDomChecks() {
    scanDom();
    watchDom();

    var passes = 0;

    var iv = setInterval(function () {
      passes++;
      scanDom();

      if (passes >= CONFIG.maxRescans) {
        clearInterval(iv);
      }
    }, CONFIG.rescanIntervalMs);
  }

  runImmediateChecks();

  if (document.readyState === 'loading') {
    if (document.documentElement) {
      watchDom();
    }

    document.addEventListener('DOMContentLoaded', runDomChecks);
  } else {
    runDomChecks();
  }
})();